import React from "react"
import OrganizationForm from "./OrganizationForm"

export default function CreateNewOrganization() {
  return <OrganizationForm />
}



// WEBPACK FOOTER //
// ./src/components/Organizations/CreateNewOrganization.js